import { render, staticRenderFns } from "./ReportsServicesDashboard.vue?vue&type=template&id=5c0fe633&scoped=true"
import script from "./ReportsServicesDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsServicesDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReportsServicesDashboard.vue?vue&type=style&index=0&id=5c0fe633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fe633",
  null
  
)

export default component.exports